import { useMemo } from "react";
import { useAtomValue } from "jotai";

import { useActiveLibraryItemMainTab } from "@src/features/libraryItem/contexts/libraryItemMainTabStore";
import useContentPermissions from "@src/features/libraryItem/hooks/useContentPermissions";
import { ContentPermissionsFragment } from "@src/features/libraryItem/hooks/useContentPermissions.generated";

import { selectedTrainingResourceIdAtom } from "../atoms";

/**
 * The content permissions of the resource on the canvas. On the redesigned
 * page the "preview" tab is the read-only draft view, so editing is masked
 * off there the way the module's and check-in's own hooks mask it; the store
 * reports nothing on the previous page, so nothing changes for a resource
 * embedded in a builder that still ships it.
 */
const useTrainingResourceContentPermissions = ():
  | ContentPermissionsFragment
  | undefined => {
  const trainingResourceId = useAtomValue(selectedTrainingResourceIdAtom);
  const permissions = useContentPermissions({ trainingResourceId });
  const viewingTab = useActiveLibraryItemMainTab() === "preview";
  return useMemo(() => {
    if (!permissions) return undefined;
    if (!viewingTab) return permissions;
    return { ...permissions, hasEditContentPermission: false };
  }, [permissions, viewingTab]);
};

export default useTrainingResourceContentPermissions;
